<template>
  <div>
    <boleto-title-loader class="boleto-title-loader" />
    <price-card :full-value="null" :due-date="null" />
    <caption-loader class="z-caption spacer-bottom-s" />
    <boleto-bar-code-loader class="payment-code" />
    <div class="row">
      <div class="col-md-6">
        <button-loader class="spacer-bottom-m" />
      </div>
      <div class="col-md-6">
        <button-loader />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.boleto-title-loader,
.payment-code {
  margin-bottom: var(--space-extra-large);
}
</style>

<script>
import BoletoBarCodeLoader from 'content-loaders/boleto/boleto-bar-code-loader';
import BoletoTitleLoader from 'content-loaders/boleto/boleto-title-loader';
import ButtonLoader from 'content-loaders/button-loader';
import CaptionLoader from 'content-loaders/caption-loader';
import PriceCard from 'components/price-card';

export default {
  components: {
    BoletoBarCodeLoader,
    BoletoTitleLoader,
    ButtonLoader,
    CaptionLoader,
    PriceCard,
  },
};
</script>
